import { render, staticRenderFns } from "./ItemDropdown.vue?vue&type=template&id=ef379c4a&scoped=true"
import script from "./ItemDropdown.vue?vue&type=script&lang=js"
export * from "./ItemDropdown.vue?vue&type=script&lang=js"
import style0 from "./ItemDropdown.vue?vue&type=style&index=0&id=ef379c4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef379c4a",
  null
  
)

export default component.exports